import { resetModulesMetadata } from "../helpers";

const historyMaxLength = 12;
export class DrawingHistory {
	constructor(canvas) {
		this._canvas = canvas;
		this.reset();
		this._canvas.on({
			"object:added": (e) => {
				let obj = e.target;
				if (obj && obj.type !== "textbox" || (obj.type === "textbox" && obj.text.length)) {
					this.save();
				}
			},
			"object:modified": () => {
				this.save();
			},
			"object:removed": () => {
				this.save();
			}
		});
	}

	reset() {
		this._handlers = [];
		this._history = [];
		this._step = -1;
		this._pause = false;
		this._isShifted = false;
	}

	get isStart() {
		return this._step < 1;
	}

	get isEnd() {
		return this._step === this._history.length - 1;
	}

	get current() {
		return this._history[this._step];
	}

	pause() {
		this._pause = true;
	}

	unpause() {
		this._pause = false;
	}

	save() {
		if (this._pause) return;

		let record = JSON.stringify(this._canvas.toJSON());

		if (this._step === historyMaxLength - 1) {
			this._history.shift();
			this._isShifted = true;
		} else if (this._step < this._history.length - 1) {
			this._history.splice(this._step + 1);
		}

		this._history.push(record);

		if (this._step < historyMaxLength - 1) {
			this._step++;
		}

		if (this.saveCallback) this.saveCallback();
	}

	undo() {
		if (this.back()) {
			this.__reloadFromHistory();
		}
	}

	redo() {
		if (this.forward()) {
			this.__reloadFromHistory();
		}
	}

	__reloadFromHistory() {
		this.pause();
		this._canvas.loadFromJSON(this.current, () => {
			this._canvas.renderAll();
			resetModulesMetadata(this._canvas);
			this.unpause();
		});
	}

	back() {
		let moved = false;
		if (this._history.length > 1 && this._step > 0) {
			this._step--;
			moved = true;
			if (this.saveCallback) this.saveCallback();
		}
		return moved;
	}

	forward() {
		let moved = false;
		if (this._step < historyMaxLength - 1 &&
			this._step < this._history.length - 1) {
			this._step++;
			moved = true;
			if (this.saveCallback) this.saveCallback();
		}
		return moved;
	}
}
